module.exports = __webpack_public_path__ + "img/shipin3.d958c411.jpg";